var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.DynamicComponent,{ref:"form_action",tag:"component",attrs:{"args":_vm.args,"finished":_vm.finished},on:{"update:finished":function($event){_vm.finished=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }